import { toast } from 'react-toastify';

import { takeLatest, call, put, all } from 'redux-saga/effects';

import api from '~/services/api';
import history from '~/services/history';

import { forgotInSuccess, forgotFailure } from './actions';

export function* forgotIn({ payload }) {
  try {
    const { usuario, cpf } = payload;

    let { subdominio } = payload;

    if (process.env.NODE_ENV === 'development') {
      subdominio = 'sgta-dev';
      //subdominio = 'Abastek';
    }

    const { data } = yield call(api.post, 'esqueciminhasenha', {
      subdominio,
      usuario,
      cpf,
    });

    //toast.success("Solicitação foi recebida! Email enviado para o email cadastrado!!");

    yield put(forgotInSuccess(usuario, cpf));

    history.push('/');
  } catch (erros) {
    erros.map((error) => toast.error(error));
    yield put(forgotFailure());
  }
}


export function* forgotSuccess({ payload }) {
  try {
    const { usuario, cpf } = payload;

    let { subdominio } = payload;

    if (process.env.NODE_ENV === 'development') {
      subdominio = 'sgta-dev';
      //subdominio = 'Abastek';
    }

    toast.success("Solicitação foi recebida! Email enviado para o email cadastrado!!");


    history.push('/');
  } catch (erros) {
    erros.map((error) => toast.error(error));
    yield put(forgotFailure());
  }
}


export default all([
  takeLatest('@forgot/FORGOT_IN_REQUEST', forgotIn),
  takeLatest('@forgot/FORGOT_IN_SUCCESS', forgotSuccess),

]);
